// Tanggal "hari ini" berdasarkan waktu LOKAL browser (bukan UTC), format YYYY-MM-DD.
//
// Kenapa ini penting: `new Date().toISOString()` selalu memakai UTC. Untuk WIB (UTC+7),
// setiap jam 00:00–06:59 WIB, waktu UTC masih menunjukkan tanggal KEMARIN — jadi kalau
// dipakai untuk cek "apakah hari ini termasuk hari libur / PO aktif", hasilnya bisa salah
// di jam-jam tersebut. Pakai helper ini untuk semua perbandingan tanggal "hari ini".
export function localDateStr(d = new Date()) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
